module.exports = __webpack_public_path__ + "static/hiragana-959aea78342708b130bc2ba448b88209.jpg";